module.exports = __webpack_public_path__ + "img/146856impactmedia.dead33f9.jpg";